import { useContext, useMemo } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { useModal } from 'components/modals'

import { Box, Typography } from '@mui/material'
import { v4 as uuidv4 } from 'uuid'
import { AssetInnerTable, AccountRow, CallToActionRow } from 'atoms/AssetsTable'

export default function FamilyAssets({ demoMode = false }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)
  const { updateIntakeStateAndSubmit } = useFormDebounce()
  const { openModal } = useModal()

  const dependents = (intakeState?.familyDependents || []).map((d) => ({
    ...d,
    id: d.id || uuidv4(),
  }))

  const rows = useMemo(() => {
    if (!dependents || dependents.length === 0) {
      return [
        <CallToActionRow
          key="noDependents"
          text="Add your first Child"
          onClick={() =>
            !demoMode &&
            openModal('addChild', {
              dependents,
              updateIntakeStateAndSubmit,
              updateIntakeStateAtKey,
            })
          }
        />,
      ]
    }

    return dependents.map((child) => (
      <AccountRow
        key={child.id}
        name={child.name || 'Child'}
        amount={child.age || 0}
        subType="child"
        isCurrency={false}
        onClick={() =>
          openModal('addChild', {
            child,
            dependents,
            updateIntakeStateAndSubmit,
            updateIntakeStateAtKey,
          })
        }
      />
    ))
  }, [
    dependents,
    demoMode,
    openModal,
    updateIntakeStateAndSubmit,
    updateIntakeStateAtKey,
  ])

  return (
    <>
      <AssetInnerTable
        rows={rows}
        addAccountRow="Add a Child"
        openModal={openModal}
        openToPage="Children"
        onAddClick={() =>
          !demoMode &&
          openModal('addChild', {
            dependents,
            updateIntakeStateAndSubmit,
            updateIntakeStateAtKey,
          })
        }
      />
    </>
  )
}
